export default {
      id: "mapModal-usage",
      viewBox: "0 0 30 40",
      url: __webpack_public_path__ + "img/icons.f759dcb6.svg#mapModal",
      toString: function () {
        return this.url;
      }
    }